// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EDVD","label":"styles_label__2X_N8"};